$(function() {

	// CLick one, click another
	$('[data-select-to]').on('click', function() {
		$('#' + $(this).data('select-to')).click();
	});

});
